import { Injectable } from '@angular/core';
import * as socketIO from 'socket.io-client';
import Socket = SocketIOClient.Socket;
import { ConfigService } from './config.service';

@Injectable()
export class AdminSocketService {
  public socket: Socket;

  public init() {
    if (!this.socket) {
      this.socket = socketIO(ConfigService.config.socketIOAddress);
    }
  }

  public close() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
    }
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/admin.socket.service.ts